
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/staycation/staycations",
      function () {
        return require("private-next-pages/staycation/staycations.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/staycation/staycations"])
      });
    }
  